<template>
  <div class="lista">
    <!-- MB tracking code -->
    <img
      style="width:1px; height:1px;"
      :src="'https://servedby.flashtalking.com/imp/2/112659;4041199;201;pixel;Forbes;ForbesROSlistasponsorship/?cachebuster='+timecurr()"
    />
    <!-- MB tracking code -->
    <img
      class="bglines"
      src="../assets/bgpattern.png"
    >
    <div class="inner">
      <Fullpagelist />
      <ThumbsNavComponent />
    </div>
  </div>
</template>
<script>
import Fullpagelist from '../components/Fullpagelist.vue';
import ThumbsNavComponent from '../components/Thumbsnav.vue';

export default {
  name: 'lista',
  components: {
    Fullpagelist,
    ThumbsNavComponent,
  },
  data() {
    return {
    };
  },
  methods: {
    timecurr() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth()}${time.getDate()}${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
    },
  },
  mounted() {
    this.timecurr();
  },
  created() {
    this.$store.dispatch('loadItems');
  },
  computed: {
  },
};
</script>

<style scoped lang="css">
</style>
